import { useCallback } from 'react';
import copy from 'copy-to-clipboard';

export const useClipboard = ({ onCopy }: { onCopy?: () => void }) => {
  const copyToClipboard = useCallback(
    (content: any) => {
      if (copy(content)) {
        onCopy && onCopy();
      }
    },
    [onCopy]
  );

  return { copyToClipboard };
};
